import { render, staticRenderFns } from "./DefaulCliBarragan.vue?vue&type=template&id=534de832&scoped=true"
import script from "./DefaulCliBarragan.vue?vue&type=script&lang=js"
export * from "./DefaulCliBarragan.vue?vue&type=script&lang=js"
import style0 from "./DefaulCliBarragan.vue?vue&type=style&index=0&id=534de832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534de832",
  null
  
)

export default component.exports